<template>
  <setting-form :edit="edit" @added="backToList" @updated="backToList" @cancel="backToList" />
</template>
<script>
import SettingForm from '@/components/forms/SettingForm';

// @vuese
// Formularz do edycji ustawień
// @group Setting
export default {
  components: {
    SettingForm
  },
  props: {
    // Czy edycja
    edit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    // @vuese
    // Powrót do listy ustawień
    backToList() {
      this.$router.push({ name: 'settings' });
    }
  }
};
</script>